import type { NotificationSetting } from "../models/NotificationSetting";
import type { KeyValue } from "../models/KeyValue";
import { CreateCrudService } from "./CrudServiceFactory";
export function NotificationSettingService() {
  return CreateCrudService<NotificationSetting, KeyValue>({
    Route: "notification",
    PaginationInPath: true,
    EntityName: "Notification",
    PartialFields: ["Code"],
    LoadingMessage: "Loading notification settings...",
    SavingMessage: "Saving notification settings...",
  });
}
